/** Flat to-do item node with expandable and level information */
  export class UserFlatNode {
    item: string;
    level: number;
    expandable: boolean;
  }

